import {
    EngineRuntimeName,
    EngineRuntime,
    WidgetName,
    EngineRuntimeFeedButtonVisualSettings,
} from "@kaltura/unisphere-in-app-messaging-core";
import { UnisphereRuntimeVisual, useGetUnisphereWorkspace } from "@unisphere/runtime-react";
import { useEffect, useMemo, useState } from "react";
import { styled } from "@mui/material";

const buttonVisualType = "feedButton";

export const InAppMessagingButton = () => {
    const [runtime, setRuntime] = useState<EngineRuntime>();
    const [buttonVisible, setButtonVisible] = useState(false);

    const buttonSettings = useMemo<EngineRuntimeFeedButtonVisualSettings>(() => ({ variant: "mediaspace-ds" }), []);

    const { unisphereWorkspace } = useGetUnisphereWorkspace();
    useEffect(() => {
        if (!unisphereWorkspace) {
            return;
        }

        (async () => {
            try {
                const runtime = await unisphereWorkspace.getRuntimeAsync<EngineRuntime>(WidgetName, EngineRuntimeName);
                if (runtime) {
                    setRuntime(runtime);
                }
            }
            catch (error: unknown) {
                console.error("Failed to get InAppMessaging runtime:", error);
            }
        })();
    }, [unisphereWorkspace]);

    useEffect(() => {
        if (!runtime) {
            return;
        }

        // Note: the method returns a disposer, so return it
        return runtime.onVisualVisibilityChanged(
            (data) => {
                if (data.visualType === buttonVisualType) {
                    setButtonVisible(data.visible);
                }
            },
            { replayLastValue: true }
        );
    }, [runtime]);

    return (
        <StyledWrapper className={"kms-ds-in-app-messaging-button"} visible={buttonVisible}>
            <UnisphereRuntimeVisual
                runtimeName={EngineRuntimeName}
                widgetName={WidgetName}
                visualType={buttonVisualType}
                visualSettings={buttonSettings}
            />
        </StyledWrapper>
    );
};

const StyledWrapper = styled("div")<{ visible: boolean }>(({ theme, visible }) => ({
    marginRight: theme.spacing(visible ? 1 : 0),
}));
